import numeral from 'numeral';
// 金额
export const MoneyFormat = {
    format: (amount) => {
        if (amount) {
            return numeral(amount).format('0,0.00')

        }
        return '0.00'

    },
    formatOne: (amount) => {
        if (amount) {
            return numeral(amount).format('0,0.0')

        }
        return '0.0'
    },
    formatTwo: (amount) => {
        if (amount) {
            return numeral(amount).format('0,0.00')

        }
        return '0.00'

    },
    formatThree: (amount) => {
        if (amount) {
            return numeral(amount).format('0,0.000')

        }
        return '0.000'

    },
    formatFour: (amount) => {
        if (amount) {
            return numeral(amount).format('0,0.0000')

        }
        return '0.0000'

    },
    formatFive: (amount) => {
        if (amount) {
            return numeral(amount).format('0,0.00000')

        }
        return '0.00000'

    },
    formatByDecimalCount: (amount, decimalCount) => {
        let format = '0,';
        let format2 = '0.0';
        for (let i = 1; i < decimalCount; i++) {
            format2 += '0';
        }
        format = format + format2;

        if (amount) {
            return numeral(amount).format(format)

        }
        return format2

    },
    formatForCN: (amount) => {
        if (amount) {
            let fraction = ['角', '分'];
            let digit = [
                '零', '壹', '贰', '叁', '肆',
                '伍', '陆', '柒', '捌', '玖'
            ];
            let unit = [
                ['元', '万', '亿'],
                ['', '拾', '佰', '仟']
            ];
            let head = amount < 0 ? '欠' : '';
            amount = Math.abs(amount);
            let s = '';
            for (let i = 0; i < fraction.length; i++) {
                s += (digit[Math.floor(amount * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '');
            }
            s = s || '整';
            amount = Math.floor(amount);
            for (let i = 0; i < unit[0].length && amount > 0; i++) {
                let p = '';
                for (let j = 0; j < unit[1].length && amount > 0; j++) {
                    p = digit[amount % 10] + unit[1][j] + p;
                    amount = Math.floor(amount / 10);
                }
                s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
            }
            return head + s.replace(/(零.)*零元/, '元')
                .replace(/(零.)+/g, '零')
                .replace(/^整$/, '零元整');
        }
        return '零元整';
    },
    formatThreeByComma: (amount) => {
        if (amount) {
            return numeral(amount).format('0,0')
        }

        return '0';
    }
}
//公里
export const KilometreFormat = {

    format: (kilometre) => {
        if (kilometre) {
            return numeral(kilometre).format('0.000')

        }
        return '0.000'

    },

}

//公里,保留0.0
export const KilometreKeepFormat = {

    format: (kilometre) => {
        if (kilometre) {
            return numeral(kilometre).format('0.0')

        }
        return '0.0'

    },

}
export const CNFormat = {

    formatNumber(num) {
        let changeNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
        let unit = ["", "十", "百", "千", "万"];
        num = parseInt(num);
        let getWan = (temp) => {
            let strArr = temp.toString().split("").reverse();
            let newNum = "";
            for (var i = 0; i < strArr.length; i++) {
                newNum = (i === 0 && strArr[i] === 0 ? "" : (i > 0 && strArr[i] === 0 && strArr[i - 1] === 0 ? "" : changeNum[strArr[i]] + (strArr[i] === 0 ? unit[0] : unit[i]))) + newNum;
            }
            return newNum;
        }
        let overWan = Math.floor(num / 10000);
        let noWan = num % 10000;
        if (noWan.toString().length < 4) {
            noWan = "0" + noWan;
        }
        return overWan ? getWan(overWan) + "万" + getWan(noWan) : getWan(num);
    }
}


